<template>
  <input
    class="appearance-none absolute top-0 left-0 bottom-0 right-0 [&:not(:checked)]:cursor-pointer"
    type="radio"
  />
</template>

<script>
  export default {
    name: "VInputRadio",
  };
</script>
